import { archiveReasonLabels } from "@albertine/types";
import { ArchiveMemberRequestSchema } from "@albertine/types/openapi/lmt";
import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "react-hook-form";
import { z } from "zod";
import { useMemberProfile } from "../MemberProfileContext";
import { ProfileParagraph } from "../profilePrimitives";
import { OwnedField } from "./FormFields";
import { FormShell } from "./ProfileOverlayShell";
import type { FormProps } from "./types";

const ARCHIVE_OPTIONS = archiveReasonLabels.map(([id, label]) => ({ id, label }));

const archiveFormSchema = z.object({
    reason: z
        .string()
        .min(1, "Reason is required")
        .pipe(ArchiveMemberRequestSchema.shape.archiveReason),
});

export function ArchiveForm({ onClose }: FormProps) {
    const { profile, archive } = useMemberProfile();
    const hasGroups = profile.membership.groups.length > 0;
    const { control, handleSubmit, watch } = useForm({
        resolver: zodResolver(archiveFormSchema),
        defaultValues: { reason: "" },
    });
    const reason = watch("reason");

    return (
        <FormShell
            title="Archive member"
            onClose={onClose}
            onSave={handleSubmit((values) => {
                archive({ archiveReason: values.reason }, onClose);
            })}
            saveLabel="Archive member"
            saveDisabled={hasGroups || !reason}
        >
            <OwnedField
                id="archive-reason"
                label="Reason"
                kind="select"
                options={ARCHIVE_OPTIONS}
                control={control}
                name="reason"
            />
            {hasGroups && (
                <ProfileParagraph muted>
                    You must first remove member from all groups.
                </ProfileParagraph>
            )}
            <ProfileParagraph muted>
                By archiving a member you make their user account inactive and they are
                not shown in the member list.
            </ProfileParagraph>
        </FormShell>
    );
}
